import {
  GET_INTERNALSAMPLE,
  GET_INTERNALSAMPLE_FAIL,
  GET_INTERNALSAMPLE_SUCCESS,
  GET_INTERNALSAMPLES,
  GET_INTERNALSAMPLES_FAIL,
  GET_INTERNALSAMPLES_SUCCESS,
  ADD_NEW_INTERNALSAMPLE,
  ADD_INTERNALSAMPLE_SUCCESS,
  ADD_INTERNALSAMPLE_FAIL,
  UPDATE_INTERNALSAMPLE,
  UPDATE_INTERNALSAMPLE_SUCCESS,
  UPDATE_INTERNALSAMPLE_FAIL,
  DELETE_INTERNALSAMPLE,
  DELETE_INTERNALSAMPLE_SUCCESS,
  DELETE_INTERNALSAMPLE_FAIL,
  SET_STATE_INTERNALSAMPLE,
  UPDATE_INTERNALSAMPLE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_INTERNALSAMPLE,
  payload: loading,
})

export const getInternalSamples = ( params ) => ({
  type: GET_INTERNALSAMPLES,
  payload: { params },
})

export const getInternalSamplesSuccess = (internalSamples, totalPages, currentPage) => ({
  type: GET_INTERNALSAMPLES_SUCCESS,
  payload: { internalSamples:internalSamples, total:totalPages, currentPage:currentPage}
})

export const getInternalSamplesFail = error => ({
  type: GET_INTERNALSAMPLES_FAIL,
  payload: error,
})

export const addNewInternalSample = internalSample => ({
  type: ADD_NEW_INTERNALSAMPLE,
  payload: internalSample,
})

export const addInternalSampleSuccess = internalSample => ({
  type: ADD_INTERNALSAMPLE_SUCCESS,
  payload: internalSample,
})  

export const addInternalSampleFail = error => ({
  type: ADD_INTERNALSAMPLE_FAIL,
  payload: error,
})

export const updateInternalSample = internalSample => ({
  type: UPDATE_INTERNALSAMPLE,
  payload: internalSample,
})

export const updateInternalSampleStatus = internalSample => ({
  type: UPDATE_INTERNALSAMPLE_STATUS,
  payload: internalSample,
})

export const updateInternalSampleSuccess = internalSample => ({
  type: UPDATE_INTERNALSAMPLE_SUCCESS,
  payload: internalSample,
})

export const updateInternalSampleFail = error => ({
  type: UPDATE_INTERNALSAMPLE_FAIL,
  payload: error,
})

export const deleteInternalSample = internalSample => ({
  type: DELETE_INTERNALSAMPLE,
  payload: internalSample,
})

export const deleteInternalSampleSuccess = id => ({
  type: DELETE_INTERNALSAMPLE_SUCCESS,
  id,
})

export const deleteInternalSampleFail = error => ({
  type: DELETE_INTERNALSAMPLE_FAIL,
  payload: error,
})

export const getInternalSample = () => ({
  type: GET_INTERNALSAMPLE,
})

export const getInternalSampleSuccess = internalSample => ({
  type: GET_INTERNALSAMPLE_SUCCESS,
  payload: internalSample,
})

export const getInternalSampleFail = error => ({
  type: GET_INTERNALSAMPLE_FAIL,
  payload: error,
})
